import React from 'react';
import styled from '@emotion/styled';

import photomelissa from '../../static/team/photo-melissa.webp';
import photoclaire from '../../static/team/photo-claire.webp';
import photoamandine from '../../static/team/photo-amandine.webp';
import photodavid from '../../static/team/photo-david.webp';
import photosophie from '../../static/team/photo-sophie.webp';
import photoxavier from '../../static/team/photo-xavier.webp';

import photoagathe from '../../static/team/photo-agathe.webp';
import photocoline from '../../static/team/photo-coline.webp';
import photoludo from '../../static/team/photo-ludo.webp';
import photopatrick from '../../static/team/photo-patrick.webp';
import photoremi from '../../static/team/photo-remi-papon.webp';
import photoDianeDupraz from '../../static/team/photo-diane-dupraz.webp';
import photoflorentGoumy from '../../static/team/photo-florent-goumy.webp';
import photoFlorentVentura from '../../static/team/photo-florent-ventura.webp';
import photoNathalieVigneron from '../../static/team/photo-nathalie-vigneron-larosa.webp';

const TeamMember = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 150px;
  gap: 1rem;

  margin-bottom: 0.5rem;
  img {
    height: 90px;
    width: 90px;

    @media only screen and (max-width: 768px) {
      height: auto;
      width: 90px;
    }
  }
`;

const MemberName = styled.span`
  text-align: center;
`;

export const Team = () => {
  const teamMembers = [
    { imgSrc: photoagathe, name: 'Agathe Gajac' },
    { imgSrc: photoamandine, name: 'Amandine Godet' },
    { imgSrc: photoclaire, name: 'Claire Basso' },
    { imgSrc: photocoline, name: 'Coline Cherbonnel' },
    { imgSrc: photodavid, name: 'David Lucas' },
    { imgSrc: photoDianeDupraz, name: 'Diane Dupraz' },
    { imgSrc: photoflorentGoumy, name: 'Florent Goumy' },
    { imgSrc: photoFlorentVentura, name: 'Florent Ventura' },
    { imgSrc: photoludo, name: 'Ludovic Moulard' },
    { imgSrc: photomelissa, name: 'Mélissa Perez' },
    { imgSrc: photoNathalieVigneron, name: 'Nathalie Vigneron-Larosa' }, // TODO
    { imgSrc: photopatrick, name: 'Patrick Ear' },
    { imgSrc: photoremi, name: 'Rémi Papon' },
    { imgSrc: photosophie, name: 'Sophie Plazanet' },
    { imgSrc: photoxavier, name: 'Xavier Rule' },
  ];

  return (
    <>
      {teamMembers.map((m, idx) => {
        return (
          <TeamMember key={idx}>
            <img src={m.imgSrc} alt={m.name} loading="lazy" />
            <MemberName>{m.name}</MemberName>
          </TeamMember>
        );
      })}
    </>
  );
};
